import { httpInstance } from '@/services/httpInstance';

const getProvinceService = async () => {
  let res;
  const endpoint = '/frontlabels/v1/addresses/provinces/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getProvinceService;
